<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>

        <BreadcrumbItem to="">食堂消费</BreadcrumbItem>
        <BreadcrumbItem to="">食堂设备</BreadcrumbItem>

      </Breadcrumb>
    </Row>

    <section class='tabelContent'>

      <tablePage border :queryData="queryData" :searchParam='searchParam' @selectLcd='selectLcd' :issearch='issearch'
        @smodal='sModal'></tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>


    <Modal v-model='showhis' width='800px' style='height:600px' title='消费历史'>
      <tablePage border :queryData="columnshis" :issearch='isshowhis'></tablePage>
    </Modal>
  </section>
</template>

<script>
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'lcdlist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      screenImg: '',
      stuFace: false,
      schoolData: [],
      curlcd: {},
      showSingleModal: false,
      cjType: '巡课实况',
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['canteenDevice/getId', 'canteenDevice/save', 'canteenDevice/delete'],
        [
          {
            type: 'input',
            name: 'name',
            title: '食堂名称'
          },
          {
            type: 'multSelect',
            title: '关联单位',
            name: 'departid',
            model: '',
            children: []
          },


          {
            type: 'input',
            name: 'code',
            title: '激活码'
          },
          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }]
          }
        ]
      ],
      columnshis: [
        'canteenRecord/queryByDay',
        [{
          title: '设备名称',
          key: 'name',
          align: 'center',
        },
        {
          title: '消费次数',
          key: 'number',
          align: 'center',
        },
        {
          title: '消费金额（元）',
          key: 'total',
          align: 'center',
        },

        ]
      ],
      queryData: ['canteenDevice/getQueryList',
        [
          {
            title: '备注',
            key: '',
            width: 150,
            align: 'left',
            sortable: true,
            render: (h, params) => {
              var item = params.row.name
              return h('strong', item)
            }
          },
          {
            title: 'SN序列号',
            key: 'guid',
            sortable: true,
          },


          {
            title: '注册时间',
            sortable: true,
            key: 'addtime',
            width: 180,
            align: 'center',
          },
          // {
          // 	title: '消费记录',
          // 	key: '',
          // 	align: 'center',
          // 	width:'230px',
          // 	render: (h, params) => {
          // 		 return h('div', [
          // 				h('span', {
          // 					style: {

          // 						textDecoration:'underline',
          // 						color:'#00d186',
          // 						cursor:'pointer'
          // 					},
          // 					on: {
          // 						click: () => {

          // 							this.getHisData(params.row.guid,params.row)

          // 						}
          // 					}
          // 				}, '消费历史'),

          // 			]);
          // 	}
          // },
          {
            title: '是否激活',
            key: 'code',
            width: 100,
            align: 'center',
            render: (h, params) => {
              var c = params.row.code
              if (c != '' && c != null) {
                return h('span', {
                  style: {
                    color: "rgb(0, 201, 219)",
                    backgroundColor: "rgba(0, 201, 219, 0.1)",
                    padding: "2px 8px",
                    borderRadius: '7px',
                    fontSize: '11px',
                    display: 'inline-block',
                  }

                }, '是')
              } else {
                return h('span', {
                  style: {
                    color: "#ed4c78",
                    backgroundColor: "rgba(237,76,120,.1)",
                    padding: "2px 8px",
                    borderRadius: '7px',
                    fontSize: '11px',
                    display: 'inline-block',
                  }

                }, '否')
              }
            }
          },

          {
            title: '编辑',
            slot: 'action',
            align: 'center',
            width: 80,
          }

        ],
        {
          type: 1,
          filterTa: 'guid',
          filterRowData: 'inch'
        }
      ],
      searchParam: {
        guid: '',
      },
      curSchoolid: -1,
      issearch: -1,
      upLV: false,
      selectList: [],
      placelist: [],
      isshowhis: -1,
      showhis: false,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    var that = this
    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))

    this.getPlace()
  },
  methods: {
    getHisData (name, row) {
      console.log(name, row)
      this.showhis = true
      this.isshowhis = Math.random()
      var url = this.columnshis[0].split("?")[0]
      this.columnshis[0] = url + '?sn=' + name
    },
    getPlace () {
      var that = this
      this.axios.get('dic/getQueryList.do?rootid=depart&length=-1', { params: {} }).then(res => {
        console.log(res)
        var _data = res.data
        _data.map(function (val, index) {
          val['value'] = val['guid']
        })
        that.formData[1][1]['children'] = that.placelist = _data

      })
    },
    selectLcd (a) {
      this.upLV = a.length > 0 ? true : false
      this.selectList = a
    },

    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid, row) {
      console.log(guid, 'guid', this.formData[0][0])
      this.reloadTmep = Math.random()
      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }

      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    },
    getSingleInfo (data) {
      this.showSingleModal = true
    },

    searchSchoolData (val) {

      if (val.length == 3) {

        this.searchParam.gradeid = val[1]
        this.searchParam.classid = val[2]
      } else if (val.length == 2) {
        // this.searchParam.schoolid = val[0]
        this.searchParam.gradeid = val[0]
        this.searchParam.classid = val[1]
      } else {

        this.searchParam.gradeid = val[0]
        this.searchParam.classid = 0
      }
    },
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
}

.selfbtn {
  margin: 10px;

}
</style>
